import selectStyles from "components/olitask/donations/credits/selectStyles";
import React, { useState } from "react";
import { Col } from "react-bootstrap";
import AsyncSelect from "react-select/async";

export default function UserSelector({
  searchUserProfiles,
  loading,
  selectedUser,
  setSelectedUser,
}) {
  const [users, setUsers] = useState([]);

  // Async loader for users
  const loadUsers = async (inputValue) => {
    const results = await searchUserProfiles(inputValue);
    setUsers(results);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(
          results.map((u) => ({
            value: u.id,
            label: `${u.firstName} ${u.lastName} (${u.email})`,
          }))
        );
      }, 1000);
    });
  };

  return (
    <Col className="col-12">
      <label className="form-label text-xxs mb-0 mb-2">Select User</label>
      <AsyncSelect
        cacheOptions
        defaultOptions={users.map((u) => ({
          value: u.id,
          label: `${u.firstName} ${u.lastName} (${u.email})`,
        }))}
        loadOptions={loadUsers}
        onChange={(opt) => setSelectedUser(opt)}
        value={selectedUser}
        placeholder="Search and select user..."
        isClearable
        isLoading={loading}
        styles={selectStyles}
      />
    </Col>
  );
}
